import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 90vh;
`;

const OccasionsList = styled.div`
  display: grid !important;
  gap: 24px;
  grid-template-columns: repeat(4, minmax(234px, 1fr));
  margin-bottom: 24px;
`;

const OccasionItem = styled.div`
  align-items: center;
  aspect-ratio: 133/109;
  background: var(--color-bg-default, #fff);
  border: 1px solid var(--color-border-default, #e5e8ef);
  border-radius: var(--size-border-radius-md, 4px);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-8);
  padding: var(--size-padding-16);
  position: relative;
  text-align: center;
`;

const ContentInner = styled.div``;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-shrink: 0;
  gap: var(--size-padding-24);
  padding: var(--size-page-padding-xs) 0 0 0;
`;
const Header = styled.div`
  align-items: center;
  display: flex;
  height: 64px;
  justify-content: space-between;
`;
const HeadRight = styled.div``;
const HeadLeft = styled.div``;
const Head = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CreateWithAIButton = styled.button`
  align-items: center;
  background: #632ee4;
  border: 2px solid #7c45e8;
  border-radius: var(--size-border-radius-circle, 1224px);
  box-shadow:
    0px 2px 20px 0px rgba(164, 108, 244, 0.2),
    0px 2px 12px 0px rgba(200, 178, 255, 0.7) inset;
  color: var(--color-fg-inverse-default, #fff);
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  gap: 4px;
  height: 32px;
  justify-content: center;
  min-width: 140px;
  overflow: hidden;
  padding: 0 14px;
  position: relative;

  &::before {
    animation: shine 5s infinite;
    background: linear-gradient(
      0deg,
      transparent 0%,
      transparent 30%,
      rgba(255, 255, 255, 0.3) 50%,
      transparent 70%,
      transparent 100%
    );
    content: '';
    height: 200%;
    left: -50%;
    position: absolute;
    top: -50%;
    transform: rotate(0deg);
    width: 200%;
  }

  &:hover::before {
    animation: shine 3s infinite;
  }

  @keyframes shine {
    0% {
      transform: translateX(-100%) translateY(-100%) rotate(0deg);
    }
    100% {
      transform: translateX(100%) translateY(100%) rotate(0deg);
    }
  }
`;

const CreateWithAIButtonWrapper = styled.div`
  display: inline-block;
  position: relative;

  &::after {
    animation: ripple 2s linear infinite;
    background: transparent;
    border-radius: var(--size-border-radius-circle, 1224px);
    bottom: 0;
    box-shadow: 0 0 0 0 rgba(99, 46, 228, 0.8);
    content: '';
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }

  &:hover::after {
    animation: ripple 1.5s linear infinite;
  }

  @keyframes ripple {
    0% {
      box-shadow: 0 0 0 0 rgba(99, 46, 228, 0.8);
    }
    50% {
      box-shadow: 0 0 0 4px rgba(99, 46, 228, 0.4);
    }
    100% {
      box-shadow: 0 0 0 8px rgba(99, 46, 228, 0);
    }
  }
`;

export {
  Content,
  ContentInner,
  CreateWithAIButton,
  CreateWithAIButtonWrapper,
  Head,
  HeadLeft,
  HeadRight,
  Header,
  OccasionItem,
  OccasionsList,
  Wrapper
};
